import { defineComponent as _defineComponent } from 'vue'
import BCXTable from '@/components/BCXTable.vue';
import { computed, PropType, ref } from 'vue';
import { Invoice, InvoiceStatus } from '@/views/my-projects/components/invoices/fakeData';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import BCXUserBannerSimple from '@/components/molecules/BCXUserBannerSimple.vue';
import { getDisplayName, getNameSortString, userNames } from '@/utils/user';
import { BcxTableFilter } from '@/models/BcxTable';
import useI18n from '@/mixins/useI18n';
import toggleArrayItem from '@/utils/toggleArrayItem';
import InvoiceIncomingExtendedRow from '@/views/my-projects/components/invoices/InvoiceIncomingExtendedRow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesTable',
  props: {
  data: {
    type: Array as PropType<Invoice[]>,
    default: () => []
  },
  type: {
    type: String as PropType<'due' | 'incoming' | 'outgoing'>,
    default: 'due'
  },
},
  setup(__props) {

const props = __props;



const { t } = useI18n();

const { getFormattedDate } = useFormattedDateTime();

const { isNarrow } = useMyProjects();

const showStatusColumn = computed(() => props.type !== 'due');
const isOutgoing = computed(() => props.type === 'outgoing');

const selectedInvoiceIDs = ref<string[]>([]);

const templateColumns = computed(() => (showStatusColumn.value ? '5fr 6fr 4fr 3fr 2fr' : '4fr 6fr 3fr 2fr'));

const mobileGridAreas = computed(() => (
  showStatusColumn.value
    ? 'user user\nreference status\ncostCenter due'
    : 'user user\nreference reference\ncostCenter due'));

const fieldNames = computed(() => (showStatusColumn.value ? ['user', 'reference', 'costCenter', 'due', 'status'] : ['user', 'reference', 'costCenter', 'due']));

const headerFieldsMobile = computed(() => (showStatusColumn.value ? ['costCenter', 'due', 'status'] : ['user', 'costCenter', 'due']));

const sortableFields = computed(() => (isNarrow.value ? headerFieldsMobile.value : fieldNames.value));

const headerTitles = computed(() => fieldNames.value.map((key) => {
  if (key === 'user') {
    return isOutgoing.value
      ? 'to' : 'from';
  }
  return key;
})
  .map((key) => `${t(`invoices.table.columns.${key}`)}`));

const displayValueCallback = (field:string, obj:Invoice) => {
  switch (field) {
    case 'due': return getFormattedDate(obj.due);
    case 'user': return obj.user;
    case 'status': return `${t(`invoices.table.filter.${obj.status}`)}`;
    case 'costCenter': return obj.costCenter;
    case 'reference': return obj.reference;
  }
  return '';
};

const sortValueCallback = (field:string, obj:Invoice) => {
  switch (field) {
    case 'due': return obj.due;
    case 'status': return obj.status;
    case 'costCenter': return obj.costCenter;
    case 'user': return getNameSortString(obj.user);
    case 'reference': return obj.reference;
  }
  return 0;
};

const searchableCallback = (search:string, obj:Invoice) => {
  const searchBlock = `${obj.reference}  ${getDisplayName(obj.user)}`.toLocaleLowerCase();
  return searchBlock.includes(search.toLocaleLowerCase());
};

const filter = computed((): BcxTableFilter => ({
  style: 'dropdown',
  isExclusive: false,
  states: isOutgoing.value ? [
    InvoiceStatus.Draft,
    InvoiceStatus.Sent,
    InvoiceStatus.Overdue,
    InvoiceStatus.Paid
  ] : [
    InvoiceStatus.New,
    InvoiceStatus.Open,
    InvoiceStatus.Overdue,
    InvoiceStatus.Paid
  ],
  stateCallback: (states: string[], obj: Invoice) => states.includes(obj.status),
  labelCallback: (state: string) => `${t(`invoices.table.filter.${state}`)}`
}));

const emptyText = computed(() => (isOutgoing.value ? t('invoices.table.empty.outgoing') : t('invoices.table.empty.incoming')));

const onSelectRow = (id:string) => {
  if (props.type !== 'incoming') return;
  selectedInvoiceIDs.value = toggleArrayItem(selectedInvoiceIDs.value, id);
};


return { __sfc: true,props, t, getFormattedDate, isNarrow, showStatusColumn, isOutgoing, selectedInvoiceIDs, templateColumns, mobileGridAreas, fieldNames, headerFieldsMobile, sortableFields, headerTitles, displayValueCallback, sortValueCallback, searchableCallback, filter, emptyText, onSelectRow, BCXTable, InvoiceStatus, BCXUserBannerSimple, getDisplayName, InvoiceIncomingExtendedRow }
}

})